<template>
  <section class="pa-section pa-section-connection-entrance">
    <div class="icon-field">
      <ConnectionEntranceImage />
    </div>

    <div class="title-field">
      <p class="text">メルティングポット</p>
      <hr class="under-line" />
    </div>

    <div class="message-field">
      <div class="text-set">
        <p>塔経市帝は異世界同士のるつぼ</p>
        <p>様々な異世界の文化や人が混じり合います。</p>
      </div>

      <div class="text-set">
        <p class="is-strong">混じり合ったとき、</p>
        <p class="is-strong">新しい何かが生まれる。</p>
      </div>

      <div class="text-set">
        <p>メルティングポットの中で</p>
        <p>新しいツナガリが生まれるでしょう。</p>
      </div>

      <div class="button-field">
        <button
         class="button"
         :class="buttonClass"
         :disabled="isDisabledButton"
         @click.prevent="handleButton"
        >メルティングポットへ</button>
      </div>
    </div>
  </section>
</template>

<script>
import ConnectionEntranceImage from '@/components/Pages/Connections/Entrance/Images/icon_logo.svg?inlineN'

import {GetMe}  from '@/graphql/queries/User.graphql'

import CharacterMetaMixins from '@/mixins/CharacterMetaMixins.js'

export default {
  components : {
    ConnectionEntranceImage
  },

  mixins : [
    CharacterMetaMixins
  ],

  data(){
    return {
      isDisabledButton  : true,

      isLoadingButton   : false,

      buttonClass       : {
        'is-loading'  : false,
      },
    };
  },

  apollo : {
    me: {
      query: GetMe
    }
  },

  watch : {
    characterMetaData : {
      handler(data){
        if(data === {}) return;

        this.isDisabledButton = false;
      },
      immediate: true,
      deep: true
    },

    isLoadingButton : {
      handler(value){
        this.buttonClass['is-loading'] = value;
      },
      immediate: true
    },
  },

  methods : {
    async handleButton(){
      this.isLoadingButton = true;

      await this.UXWaiting(1000);

      await this.updateCharacterMeta({
        'connections.showEntrance'  : false
      });

      this.isLoadingButton = false;
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.pa-layout{
  .pa-main-contents-container-logined{
    .pa-section{
      &-connection-entrance{
        background-repeat: no-repeat;
        background-position: 50% 50%;
        background-size:120%;
        background-image: url('~@/components/Pages/Connections/Entrance/Images/background.svg');
        overflow: hidden;
        user-select: none;

        padding-top:35px;
        padding-bottom:20px;

        @media screen and (min-width: $desktop) {
          background-size:100%;
        }

        .icon-field{
          text-align: center;
          // padding-top:2rem;

          @media screen and (min-width: $desktop) {
            padding-top:24px;
          }

          svg{
            width:28%;
            max-width:28%;

            @media screen and (min-width: $desktop) {
              max-width:100px;
            }

            .a{
              fill:none;
            }
          }
        }

        .title-field{
          margin-top:.3rem;
          text-align: center;

          p{
            &.text{
              font-weight: bold;
              color:#7F4F16;
              margin:0;
              padding:0;
              font-size:1.4rem;
              line-height: 1.4rem;
            }
          }

          hr.under-line{
            border:0;
            background-color:#7f4f16;
            width:14rem;
            height:4px;
            border-radius: 8px;
            margin:0 auto;
            padding:0;
            margin-top:.6rem;
          }
        }

        .message-field{
          margin-top:.5rem;
          font-family: 'mplus-1m-regular';

          .text-set{
            margin-top:.5rem;
            text-align: center;

            p{
              text-align: center;
              font-size:1.13rem;
              color:#7F4F16;

              &.is-strong{
                font-family: 'mplus-1m-medium';
              }
            }
          }

          .button-field{
            margin-top:.8rem;
            text-align: center;

            .button{
              text-align: center;
              margin:0 auto;
              padding:.2rem .5rem;
              font-size:1rem;
              color:#D2BA9E;
              background-color:#8E5B17;
              border:2px solid #7F4F16;
              height:inherit;
            }
          }
        }
      }
    }
  }
}
</style>